export const getLeapFromWindow = async () => {
  if (typeof window === 'undefined') {
    return undefined;
  }

  if (window.leap) {
    return window.leap;
  }

  if (document.readyState === 'complete') {
    return window.leap;
  }

  return new Promise((resolve) => {
    const documentStateChange = (event) => {
      if (event.target && event.target.readyState === 'complete') {
        resolve(window.leap);
        document.removeEventListener('readystatechange', documentStateChange);
        // window.addEventListener('leap_keystorechange', reconnectWallet)
      }
    };

    document.addEventListener('readystatechange', documentStateChange);
  });
};
